export default {
  isSearching: false,
  searchProductGroups: [],
  searchError: null,
};
